// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__4J_cK","paddings":"layout_paddings__F_9WO","breadcrumb":"layout_breadcrumb___gBUd","breadcrumbs":"layout_breadcrumbs__a41AT"};